module.exports = "<svg data-name=\"Layer 1\" viewBox=\"0 0 20 20\"><path d=\"M10 19a1.556 1.556 0 0 1-1.17-.516C6.925 16.33 3 10.999 3 8.037A6.843 6.843 0 0 1 10 1a6.843 6.843 0 0 1 7 7.037c0 2.962-3.926 8.292-5.83 10.446A1.556 1.556 0 0 1 10 19zm.036-13.5A3 3 0 1 0 13 8.536V8.5a2.986 2.986 0 0 0-2.964-3z\" data-name=\"Subtraction 1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/map-marker.svg
// module id = 245
// module chunks = 1